import * as Html from "../../util/Html.ts";
export {init}
Html.registerWidget('widget/specific/imdayindicator',{init:init})

function init(obj){
  var next = obj.nextAll("."+obj.get(0).className).first();
  if(next.text()===obj.text()){
    next.remove();
  }
}